import { useHistory } from "react-router-dom"
import { Button } from "src/components/ui/button"
import { ChevronRight } from "src/icons"
import "./style.scss"

export const Hero = () => {
  const history = useHistory()
  return (
    <div className="hero">
      <h1>Crypto Banking. Real IBANs. Real Freedom.</h1>
      <p>Personal and Business IBANs made for the crypto era. Send, receive, and manage funds globally — fast, easy, and borderless.</p>
      <Button onClick={() => history.push("/register/corporate")} rightIcon={<ChevronRight />}>
        GET IBAN
      </Button>
    </div>
  )
}
